import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Button, Box, Container } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import clientApi from './services/clientApi';
import logoWhite from './assets/re-stat-logo-white.svg';

// Pages
import Search from './pages/Search';
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';

// Components
import ProtectedRoute from './components/ProtectedRoute';

function AppContent() {
  const [userName, setUserName] = useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const isPublicPage = location.pathname === '/login' || location.pathname === '/reset-password';

  useEffect(() => {
    if (clientApi.isAuthenticated()) {
      setUserName(clientApi.getUserName() || clientApi.getPortalName());
    } else {
      setUserName(null);
    }
  }, [location]);

  const handleLogout = async () => {
    await clientApi.logout();
    setUserName(null);
    navigate('/login');
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      {!isPublicPage && (
        <AppBar position="static" elevation={0} sx={{ bgcolor: '#112337' }}>
          <Toolbar sx={{ minHeight: { xs: 72, sm: 80 } }}>
            <Box component="img" src={logoWhite} alt="re-stat" sx={{ height: 40 }} />
            <Box sx={{ flexGrow: 1 }} />
            {userName && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.85)' }}>{userName}</Typography>
                <Button color="inherit" size="small" startIcon={<LogoutIcon />} onClick={handleLogout}>
                  Logout
                </Button>
              </Box>
            )}
          </Toolbar>
        </AppBar>
      )}

      {isPublicPage ? (
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Routes>
      ) : (
        <Container maxWidth="xl" sx={{ py: 4 }}>
          <Routes>
            <Route path="/" element={<ProtectedRoute><Search /></ProtectedRoute>} />
            <Route path="/search" element={<ProtectedRoute><Search /></ProtectedRoute>} />
          </Routes>
        </Container>
      )}
    </Box>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
